import { keyframes } from '@emotion/react';
import { size200 } from '@hover/tokens-space';

export const autoSlide = keyframes`
  0% {
    transform: translateX(0%);
  }

  100% {
    transform: translateX(-50%);
  }
`;

export const CONSTANTS = {
  cardGap: size200,
  imageDimensions: {
    base: {
      height: 400,
      width: 240,
    },
    tablet: {
      height: 562,
      width: 318,
    },
  },
  speedMultiplier: 2.2,
};
